module.exports = __webpack_public_path__ + "img/icon-rtpn.ed253b23.svg";